import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import eventBus from 'general/js/event-bus';
import app, {
    EVENT_DEVICE_TYPE_CHANGED,
    DEVICE_TYPE_MOBILE_WIDE,
    DEVICE_TYPE_MOBILE,
} from 'general/js/app';
import { defaultTheme } from './live-event-select-themes';

class LiveEventSelect extends React.Component {
    constructor(props) {
        super(props);

        this.choicesInstance = null;
        this.selectRef = React.createRef();
    }

    componentDidMount() {
        const block = 'live-event-select';

        this.choicesInstance = new window.Choices(this.selectRef.current, {
            choices: [],
            searchEnabled: false,
            shouldSort: false,
            itemSelectText: '',
            classNames: {
                containerOuter: `${block}__outer`,
                containerInner: `${block}__inner`,
                list: `${block}__list`,
                listDropdown: `${block}__list--dropdown`,
                listSingle: `${block}__list--single`,
                item: `${block}__item`,
                itemSelectable: `${block}__item--selectable`,
                itemDisabled: `${block}__item--disabled`,
                itemChoice: `${block}__item--choice`
            }
        });

        this.updateChoices(app.deviceTypeByViewport);
        eventBus.addListener(EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.choices !== this.props.choices) {
            this.choicesInstance.setChoices(this.props.choices, 'value', 'label', true);
            this.updateChoices(app.deviceTypeByViewport);
        }
    }

    componentWillUnmount() {
        eventBus.removeListener(EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged);

        this.choicesInstance.destroy();
        this.choicesInstance = null;
    }

    onDeviceTypeChanged = (oldDeviceType, newDeviceType) => {
        this.updateChoices(newDeviceType);
    }

    getOptionValue = () => {
        const value = this.choicesInstance.getValue(true);

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    initHighlightedItem(playerSelectorWrapper, newSelectedValue) {
        const currentHighlightedItem = playerSelectorWrapper.querySelector(".live-event-select__list--dropdown .is-highlighted");
        const newHighlightItem = playerSelectorWrapper.querySelector(".live-event-select__list--dropdown [data-value='" + newSelectedValue + "']");
        if (currentHighlightedItem !== null) {
            currentHighlightedItem.classList.remove("is-highlighted");
            newHighlightItem.classList.add("is-highlighted");
        }
    }

    updateChoices(deviceType) {
        const selectedValue = this.choicesInstance.getValue(true);
        const newChoices = this.props.choices.map((choice) => {
            const mobileChoice = Object.assign({}, choice);

            if (deviceType === DEVICE_TYPE_MOBILE ||
                deviceType === DEVICE_TYPE_MOBILE_WIDE
            ) {
                mobileChoice.label = choice.mobileLabel;
            }

            if (selectedValue) {
                mobileChoice.selected = choice.value === selectedValue;
            }

            return mobileChoice;
        });

        this.choicesInstance.setChoices(newChoices, 'value', 'label', true);

        const newSelectedValue = this.choicesInstance.getValue(true);
        if (selectedValue !== newSelectedValue) {
            const modalSelector = document.querySelector("article.live-player");
            const leaderboardSelector = document.querySelector(".leaderboard__select-round");
            const roundSelector = document.querySelectorAll(".live-event-select__list--dropdown");
            if (leaderboardSelector && roundSelector.length === 1) {
                this.initHighlightedItem(leaderboardSelector, newSelectedValue);
            } else if (modalSelector) {
                this.initHighlightedItem(modalSelector, newSelectedValue);
            }
        }
    }

    render() {
        const { theme } = this.props;
        const modCss = classNames({
            'is-white': theme.isWhite,
            'is-black': theme.isBlack
        });

        return (
            <div className={`live-event-select ${modCss}`}>
                <select
                    className="live-event-select__native"
                    ref={this.selectRef}
                    onChange={this.getOptionValue}
                ></select>
                <svg className="live-event-select__arrow-down icon"
                    width="14"
                    height="6"
                    focusable="false"
                    pointerEvents="none"
                >
                    <use xlinkHref="#icon-arrow-down-blue"></use>
                </svg>
            </div>
        );
    }
}

LiveEventSelect.defaultProps = {
    theme: defaultTheme,
    choices: []
};

LiveEventSelect.propTypes = {
    choices: PropTypes.array,
    theme: PropTypes.object,
    onChange: PropTypes.func
};

export default LiveEventSelect;
